export function farloUiMasthead(element) {

  if (!element) return;

  const wrap = element.closest('.site-slider__homepage');
  if (!wrap) return;

  var prevBtn = wrap.querySelector('.carousel-prev');
  var nextBtn = wrap.querySelector('.carousel-next');
  var currentEl = wrap.querySelector('.current');
  var totalEl = wrap.querySelector('.total');

  let flkty;

  element.classList.remove('flickity-enabled', 'is-draggable');

  imagesLoaded(element, () => init());

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (flkty) flkty.resize();
    }, 150);
  });

  function init() {
    if (flkty) flkty.destroy();
    flkty = new Flickity(element, {
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      groupCells: false,
      freeScroll: false,
      draggable: true,
      adaptiveHeight: false,
      autoPlay: 3000,
      cellSelector: '.show-cell'
    });


    // Flickity lifecycle hooks MUST be after init
    flkty.on('ready', updateUI);
    flkty.on('change', updateUI);
    flkty.on('reloadCells', updateUI);
    flkty.on('cellChange', updateUI);

    flkty.resize();
    setTimeout(() => flkty.resize(), 100);
  }

  function updateUI() {
    if (!flkty) return;

    const total = flkty.slides.length;
    const index = flkty.selectedIndex;

    totalEl.textContent = total;
    currentEl.textContent = total ? index + 1 : 0;

    // Disable arrows only if wrapAround is off
    if (!flkty.options.wrapAround) {
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index === total - 1;
    }
  }

  // Arrow controls
  prevBtn.addEventListener('click', () => {
    if (flkty) flkty.previous();
  });

  nextBtn.addEventListener('click', () => {
    if (flkty) flkty.next();
  });
}
